import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';

// API URL'ini ayarla
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'http://localhost:10000';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Check if user is logged in on page load
  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const token = localStorage.getItem('token');
        
        if (token) {
          const config = {
            headers: {
              Authorization: `Bearer ${token}`
            }
          };
          
          const { data } = await axios.get('/api/auth/me', config);
          
          if (data.success) {
            setUser(data.user);
          } else {
            localStorage.removeItem('token');
          }
        }
      } catch (error) {
        localStorage.removeItem('token');
        console.error('Auth check error:', error);
      } finally {
        setLoading(false);
      }
    };

    checkLoggedIn();
  }, []);

  // Register user
  const register = async (userData) => {
    try {
      const { data } = await axios.post('/api/auth/register', userData);
      
      if (data.success) {
        localStorage.setItem('token', data.token);
        setUser(data.user);
        toast.success('Kayıt başarılı!');
        return true;
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Kayıt işlemi başarısız oldu';
      toast.error(message);
      return false;
    }
  };

  // Login user
  const login = async (userData) => {
    try {
      const { data } = await axios.post('/api/auth/login', userData);
      
      if (data.success) {
        localStorage.setItem('token', data.token);
        setUser(data.user);
        toast.success('Giriş başarılı!');
        return true;
      }
    } catch (error) {
      const message = error.response?.data?.message || 'Giriş başarısız';
      toast.error(message);
      return false;
    }
  };

  // Update user
  const updateUser = (updatedUser) => {
    setUser(updatedUser);
  };

  // Logout user
  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    toast.info('Çıkış yapıldı');
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        register,
        login,
        logout,
        updateUser
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
